import Config from '@/config';

const phoneNumber = value => Config.PHONE_VALIDATION.REGXP.test(value);

export default {
  validate: phoneNumber,
  message: Config.PHONE_VALIDATION.MESSAGE,
};
